import { http } from "@/api/client";
import type { ApiItemResponse, ApiListResponse } from "@/api/types";
import type { ShareConfig, ShareScenario } from "@/types/domain";

export const shareConfigsApi = {
  list: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<ShareConfig>>("/api/share-configs", query),
  get: (id: string) => http.get<ApiItemResponse<ShareConfig>>(`/api/share-configs/${id}`),
  create: (body: Partial<ShareConfig>) => http.post<ApiItemResponse<ShareConfig>>("/api/share-configs", body),
  update: (id: string, body: Partial<ShareConfig>) =>
    http.patch<ApiItemResponse<ShareConfig>>(`/api/share-configs/${id}`, body),
  remove: (id: string) => http.delete<ApiItemResponse<ShareConfig>>(`/api/share-configs/${id}`),
  activityLogs: (id: string) => http.get<ApiListResponse<unknown>>(`/api/share-configs/${id}/activity-logs`),
  listScenarios: () => http.get<ApiItemResponse<ShareScenario[]>>("/api/scenarios"),
  listExperiments: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<unknown>>("/api/experiments", query),
  createExperiment: (body: unknown) => http.post<ApiItemResponse<unknown>>("/api/experiments", body),
  updateExperiment: (id: string, body: unknown) => http.patch<ApiItemResponse<unknown>>(`/api/experiments/${id}`, body),
  experimentAnalysis: (id: string) => http.get<ApiItemResponse<unknown>>(`/api/experiments/${id}/analysis`),
  experimentRetention: (id: string) => http.get<ApiItemResponse<unknown>>(`/api/experiments/${id}/retention`),
};
